var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CheckboxWidget as _CheckboxWidget } from '../angular2-schema-form-shim';
import { isArray } from '../forms/schemas';
import { isWidgetRequired } from './overrides';
var CheckboxWidget = (function (_super) {
    __extends(CheckboxWidget, _super);
    function CheckboxWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.options = [];
        return _this;
    }
    Object.defineProperty(CheckboxWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    CheckboxWidget.prototype.ngAfterViewInit = function () {
        var _this = this;
        _super.prototype.ngAfterViewInit.call(this);
        this.setupOptions();
        this.loadValues();
        if (this.isArray) {
            this.formProperty.valueChanges.subscribe(function (value) {
                var vals = value || [];
                _this.checked = vals.reduce(function (acc, v) {
                    acc[v] = true;
                    return acc;
                }, {});
            });
        }
    };
    CheckboxWidget.prototype.setupOptions = function () {
        if (this.schema.type !== 'array')
            return;
        var items = this.schema.items;
        if (isArray(items)) {
            throw new TypeError('Cannot use array of schemas for checkbox items.');
        }
        var enumTitles = items.options.enum_titles;
        this.options = items.enum.map(function (value, index) { return ({
            value: value,
            label: enumTitles[index],
        }); });
    };
    Object.defineProperty(CheckboxWidget.prototype, "isArray", {
        get: function () {
            return this.schema.type === 'array';
        },
        enumerable: true,
        configurable: true
    });
    CheckboxWidget.prototype.loadValues = function () {
        if (this.isArray) {
            var value = this.formProperty.value || this.schema.default || null;
            this.checked = value ? value.reduce(function (checked, value) { checked[value] = true; return checked; }, {}) : {};
            if (!this.formProperty.value && this.schema.default) {
                this.formProperty.setValue(this.schema.default, false);
            }
        }
    };
    CheckboxWidget.prototype.checkToggle = function (option) {
        var _this = this;
        var clickedValue = option.value.toString();
        if (this.checked[clickedValue]) {
            // Remove this option
            delete this.checked[clickedValue];
        }
        else {
            // Remove all exclusive options
            this.exclusiveOptions.forEach(function (option) { return delete _this.checked[option.value]; });
            // Remove all options if this one is exclusive
            if (this.exclusiveOptions.map(function (option) { return option.value; }).includes(clickedValue)) {
                this.checked = {};
            }
            // Add this option
            this.checked[clickedValue] = true;
        }
        this.formProperty.setValue(Object.keys(this.checked), false);
    };
    Object.defineProperty(CheckboxWidget.prototype, "exclusiveOptions", {
        get: function () {
            var _this = this;
            return this.exclusiveOptionValues
                .map(function (exclusiveValue) {
                return _this.options.find(function (option) { return option.value === exclusiveValue; });
            })
                .filter(function (option) { return typeof option !== 'undefined'; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckboxWidget.prototype, "exclusiveOptionValues", {
        get: function () {
            var items = this.schema.items;
            if (isArray(items))
                return [];
            return (items.options && items.options.enumExclusive && items.options.enumExclusive) || [];
        },
        enumerable: true,
        configurable: true
    });
    CheckboxWidget.prototype.isExclusive = function (option) {
        return this.exclusiveOptionValues.includes(option.value);
    };
    CheckboxWidget.prototype.isChecked = function (value) {
        return this.checked[value.toString()];
    };
    return CheckboxWidget;
}(_CheckboxWidget));
export { CheckboxWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/checkbox.widget.ts.pre-build-optimizer.js